<template>
  <!--登录-->
  <div>
    <!--<div @click="hide" class="cover"></div>-->
    <div class="header" style="text-align: left;">
      <img src="./tiantanlogo.png" alt="">Login
    </div>
    <div class="login-box">
      <!--<div class="header">-->
        <!--<img src="./tiantanlogo.png" alt="">Sign in-->
      <!--</div>-->
      <div>
        <div class="login-contain">
          <div v-show="showErrMsg" class="errMsg">Incorrect email or password</div>
          <div v-show="showErrMsg2" class="errMsg">Please input your Email and password</div>
          <ul>
            <li>
              <label>
                <span>E-mail</span>
                <input @keydown="input" type="text" v-model="userData.email" placeholder="E-mail">
              </label>
            </li>
            <li>
              <label>
                <span>Password</span>
                <input @keydown="input" ref="pwd" v-model="userData.pwd" type="password" placeholder="Password">
              </label>
            </li>
            <li class="join">
              <p @click="doJoin">Sign Up</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="do-login">
        <button @click="doLogin">Log In</button>
        <p @click="doReset" style="color:#999;margin-left:70px;margin-top:20px;cursor:pointer">Forgot Password ?</p>
      </div>
    </div>
  </div>
</template>
<script>
  /*

   /api/register/login
   * {
   "phone":"13000000000",        //app用户登录填写
   “email”:raozhilei@163.com,  //后台管理等邮箱用户登录填写
   "pwd":"900000",           //后台管理等用户登录填写
   “identify”:”657841”,  //密码和验证码2选一，pwd为null 校验验证码
   “lng”:””,       //用户位置 经度 可选
   “lat”:””       //用户位置  纬度 可选
   “appname”:””  //app的名字
   }
   *
   * */
  import bus from '../../bus'
  import md5 from 'md5'
  export default{
    data(){
      return {
        showErrMsg: false,
        showErrMsg2: false,
        userData: {
          email: "",
          pwd: ''
        }
      }
    },
    props: {
      show: {
        type: Boolean,
        deafault: () => {
          return false;
        }
      }
    },
    methods: {
      input(){
          this.showErrMsg = false;
          this.showErrMsg2 = false;
      },
//        去往注册页面
      doJoin(){
          this.hide();
          this.$router.push('/home_en/2006/detail/reg');
      },
      doReset(){
          this.hide();
          this.$router.push('/home_en/2006/detail/reset');
      },
      hide(){
        this.$emit('hideLoginBox');
      },
      doLogin(){
          if(this.userData.email.trim().length===0 || this.userData.pwd.trim().length===0){
            this.showErrMsg = false;
            this.showErrMsg2 = true;
            return;
          }
        axios.post('/medapp/api/register/login', {
          email: this.userData.email,
          pwd: md5(this.userData.pwd)
        }).then((result) => {
          let data = result.data;
//              用户登录成功
          if (data.code === "0") {
            this.showErrMsg = false;
            this.showErrMsg2 = false;
//            获得会议id
            let cid = this.$route.params.cid;
//            保存登录令牌；
            localStorage.setItem('token', data.token.tToken);
            localStorage.setItem('user', JSON.stringify(data.user));
            localStorage.setItem('cid', cid);
            localStorage.setItem('locale', 'en');
            bus.$emit('exitActive', true);
            //判断登陆成功是否有跳回页面
            let back_url = sessionStorage.getItem("back_url");
            sessionStorage.setItem("back_url","");
            if(back_url!=null && back_url!=""){
               this.$router.push(back_url);
            }
            else{
            this.$router.push('/home_en/2006');
            }
          } else {
//                    用户登录失败
            this.showErrMsg = true;
//            this.$emit('loginSuccess', false);
          }
          this.userData.pwd = '';
          this.$refs.pwd.focus();
        })
      }
    },
    computed: {},
    mounted(){
    }
  }
</script>
<style scoped>
  .cover {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 20;
    background-color: rgba(0, 0, 0, .4);
    left: 0;
    top: 0;
  }

  .login-box {
    width: 658px;
    /*position: fixed;*/
    /*left: 50%;*/
    /*top: 50%;*/
    /*margin-left: -329px;*/
    /*margin-top: -270px;*/
    margin: 0 auto 50px;
    border: 2px solid #FFFFFF;
    background-color: #FFFFFF;
    z-index: 30;
    font-family: "Arial";
  }

  /*.header {*/
    /*height: 92px;*/
    /*background-color: #141651;*/
    /*color: #FFFFFF;*/
    /*font-size: 24px;*/
    /*text-align: center;*/
    /*line-height: 92px;*/
  /*}*/

  .header {
    height: 89px;
    background-color: #F4F4F7;
    color: #4C4E82;
    font-size: 22px;
    line-height: 89px;
  }

  .header img {
    vertical-align: middle;
    margin-left: 50px;
    margin-right: 21px;
  }
  .login-contain {
    width: 545px;
    margin: 60px auto 0;
    font-size: 20px;
  }

  .login-contain li {
    margin: 32px 0 0;
  }

  .login-contain li:first-child {
    margin-top: 0;
  }

  .login-contain li span {
    display: inline-block;
    width: 100px;
    color: #000;
    text-align: right;
    margin-right: 17px;
    line-height: 40px;
  }

  .login-contain li input {
    width: 420px;
    border: 1px solid #141651;
    line-height: 40px;
    background-color: #f3f3f6;
    box-sizing: border-box;
    padding-left: 8px;
  }

  .login-contain li.join {
    text-align: right;
    margin: 16px 0 0;
    color: #141651;
    font-size: 16px;
  }

  .login-contain li.join p {
    cursor: pointer;
    display: inline-block;
    font-size: 20px;
  }

  .do-login {
    text-align: center;
    margin-top: 40px;
  }

  .do-login button {
    color: #fff;
    background-color: #141651;
    width: 306px;
    margin-left: 80px;
    height: 40px;
    line-height: 40px;
    border: 0;
    font-size: 24px;
    cursor: pointer;
  }

  .errMsg {
    color: red;
    font-size: 14px;
    margin-left: 121px;
    margin-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// login.vue?0b4ca014